import { api } from '@/api/index'
import { Loading } from 'element-ui'

let globalLoading;
const state ={
  token: '',
  stashInfo: null,
  teamInfo: null,
  applyOrderInfo: null,
  questInfo: null,
  zcInfo: null,
  indicators: null,
  baseConfig: null,
  applyList: null,
  taskList: null,
  deviceList: null,
  deviceLocations: null,
  querySearchData: null,
  carLocusInfo: null
}
const getters = {}
const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  GET_STASH_INFO(state, stashInfo) {
    state.stashInfo = stashInfo
  },
  GET_TEAM_INFO(state, teamInfo) {
    state.teamInfo = teamInfo
  },
  GET_APPLY_ORDER_INFO(state, applyOrderInfo){
    state.applyOrderInfo = applyOrderInfo
  },
  GET_QUEST_INFO(state, questInfo) {
    state.questInfo = questInfo
  },
  GET_ZC_INFO(state, zcInfo) {
    state.zcInfo = zcInfo
  },
  GET_INDICATORS(state, indicators) {
    state.indicators = indicators
  },
  GET_CONFIG(state, baseConfig) {
    state.baseConfig = baseConfig
  },
  GET_APPLY_LIST(state, applyList) {
    state.applyList = applyList
  },
  GET_TASK_LIST(state, taskList) {
    state.taskList = taskList
  },
  GET_DEVICE_LIST(state, deviceList) {
    state.deviceList = deviceList
  },
  GET_DEVICE_LOCATIONS(state, deviceLocations) {
    state.deviceLocations = deviceLocations
  },
  SET_CARMARKERINFO(state, querySearchData) {
    state.querySearchData = querySearchData
  },
  GET_PLY_LOCUS(state, carLocusInfo) {
    state.carLocusInfo = carLocusInfo
  }
}
const actions = {
  // 获取仓库信息
  async getStashInfoFn({ commit }) {
    const stashInfo = await api.getStashInfo();
    if(stashInfo.data) {
      commit('GET_STASH_INFO', stashInfo.data)
    }
  },
  // 获取队员信息
  async getTeamInfoFn({commit}) {
    const teamInfo = await api.getTeamInfo();
    if(teamInfo.data){
      commit('GET_TEAM_INFO', teamInfo.data)
    }
  },
  // 申请单数据
  async getApplyOrderInfoFn({commit}) {
    const applyOrderInfo = await api.getApplyOrderInfo();
    if(applyOrderInfo.data) {
      commit('GET_APPLY_ORDER_INFO', applyOrderInfo.data)
    }
  },
  // 任务数据
  async getQuestInfo({commit}) {
    const questInfo = await api.getQuestInfo();
    if(questInfo.data) {
      commit('GET_QUEST_INFO', questInfo.data)
    }
  },
  // 装备状态统计
  async getZCInfo({commit}) {
    const zcInfo = await api.getZCInfo();
    if(zcInfo.data) {
      commit('GET_ZC_INFO', zcInfo.data)
    }
  },
  // 指标信息
  async getIndicators({commit}) {
    const indicators = await api.getIndicators()
    if(indicators.data) {
      commit('GET_INDICATORS', indicators.data)
    }
  },
  // 基础配置
  async getConfig({commit}) {
    const baseConfig = await api.getConfig()
    if(baseConfig.data) {
      commit('GET_CONFIG', baseConfig.data)
    }
  },
  // 资产申请列表
  async getApplyList({commit}) {
    const applyList = await api.getApplyList()
    if(applyList.data) {
      commit('GET_APPLY_LIST', applyList.data)
    }
  },
  // 任务派发列表
  async getTaskList({commit}) {
    const taskList = await api.getTaskList()
    if(taskList.data) {
      commit('GET_TASK_LIST', taskList.data)
    }
  },
  // 获取设备列表
  async getDeviceList({commit}, payload) {
    const deviceList = await api.getDeviceList(payload)
    if(deviceList.code === 1){
      commit('GET_DEVICE_LIST', deviceList.data)
    }else{
      this.$message.warning("设备列表为空")
    }
  },
  // 获取设备实时定位
  async getDeviceLocation({commit}, payload) {
    globalLoading = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    const deviceLocations = await api.getDeviceLocation(payload)
    if (deviceLocations.code === 1) {
      commit('GET_DEVICE_LOCATIONS', deviceLocations.data)
      globalLoading.close()
    }
  },
  // 获取车辆轨迹
  async getPlyLocus({commit}, payload) {
    globalLoading = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    const carLocusInfo = await api.getPlyLocus(payload)
    if (carLocusInfo.code === 1) {
      commit('GET_PLY_LOCUS', carLocusInfo.data)
      globalLoading.close()
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
